export enum SectionType {
    Rectangle = "rectangle",
    Image = "image",
    Text = "text",
    RichText = "richText",
    Option = "option",
    Tags = "tags",
    TextBox = "textbox",
    Line = "line",
    Arrow = "arrow"
}

export interface IPropInfo {
    binding: string,
    inputType: 'text' | 'number' | 'color' | 'gradientcolor' | 'dropdown' | 'file' | 'multiSelect' | 'tags' | 'none' | 'multiOptionTextBox' | 'audio' | 'decimal',
    label: string,
    name: string,
    value: any,
    hidden?: boolean,
    isReadOnly?: boolean,
    options?: IDropDownOption[] | IOptionItem[] | ITextBoxOption[]
}

export interface ITextBoxOption {
    label: string,
    labelMaxWidth?:string
    correctValue: string,
    showLabel: boolean
}

export interface IOptionItem {
    label: string,
    labelMaxWidth?:string
    isCorrect: boolean,
    showLabel: boolean
}

export interface IDropDownOption {
    label: string
    value: string
    selected?: boolean
}

export interface ISectionData {
    id: string,
    type: SectionType,
    row: number,
    col: number,
    height: number,
    width: number,
    rowCount: number,
    name: string,
    colCount: number,
    isLocked: boolean,
    options?: IOptionItem[] | ITextBoxOption[],
    selected: boolean,
    textContent: string,
    value?: any,
    x?: number,
    y?: number,
    propInfo?: IPropInfo[]
}